/**
 * @fileoverview Option sets for the KPI grid. Values mirror the enums on
 * zb_reporting_questions so a cell's value can go straight into the save
 * payload without translation.
 */

import { KG_CO2E } from "../../../../_constants/emissionUnits";

/**
 * The question types the grid creates and lists. KPIs of any other type are
 * not loaded, so they never show with a type the dropdown cannot hold.
 * @type {{ value: string, label: string }[]}
 */
export const QUESTION_TYPES = [
  { value: "quantitative", label: "Quantitative" },
  { value: "tabular_question", label: "Tabular" },
];

export const QUESTION_TYPE_VALUES = QUESTION_TYPES.map((option) => option.value);

export const FREQUENCIES = [
  { value: "EVERY_FY", label: "Every FY" },
  { value: "ONE_TIME", label: "One time" },
  { value: "CUSTOM", label: "Custom" },
];

export const AGGREGATION_METHODS = [
  { value: "SUM", label: "Sum" },
  { value: "LATEST", label: "Latest" },
  { value: "AVG", label: "Average" },
];

export const KPI_CATEGORIES = [
  { value: "E", label: "Essential" },
  { value: "L", label: "Leadership" },
  { value: "G", label: "General" },
];

export const TABLE_QUESTION_TYPES = ["tabular_question"];

export const KPI_TYPES = [
  { value: "EMISSION", label: "Emission" },
  { value: "ENERGY", label: "Energy" },
  { value: "NOx", label: "NOx" },
  { value: "SOx", label: "SOx" },
  { value: "PPM", label: "PPM" },
];

export const EMISSION_SCOPES = [
  { value: "Scope 1", label: "Scope 1" },
  { value: "Scope 2", label: "Scope 2" },
  { value: "Scope 3", label: "Scope 3" },
];


export const FACTOR_COUNTRIES = ["IN", "UK", "US"];

export const CALCULATION_METHODS = [
  { value: "DIRECT", label: "Direct — per unit", shortLabel: "Direct" },
  { value: "FUEL_ENERGY", label: "Fuel energy — density × NCV", shortLabel: "Fuel energy" },
];

export const EF_BASES = [
  { value: "GAS_MASS", label: "kg of gas × GWP" },
  { value: "CO2E", label: `Already ${KG_CO2E}` },
];

export const FACTOR_GASES = [
  { gas: "co2", label: "CO₂", ef: "efCo2", gwp: "gwpCo2" },
  { gas: "ch4", label: "CH₄", ef: "efCh4", gwp: "gwpCh4" },
  { gas: "n2o", label: "N₂O", ef: "efN2o", gwp: "gwpN2o" },
];

export const GWP_PRESETS = [
  { source: "IPCC AR6", gwpCo2: "1", gwpCh4: "29.8", gwpN2o: "273" },
  { source: "IPCC AR6 non-fossil CH4", gwpCo2: "1", gwpCh4: "27", gwpN2o: "273" },
  { source: "IPCC AR5", gwpCo2: "1", gwpCh4: "28", gwpN2o: "265" },
  { source: "IPCC AR4", gwpCo2: "1", gwpCh4: "25", gwpN2o: "298" },
];

export const AGGREGATED_TYPES = ["quantitative"];


export const TAG_PATH_KEYS = ["module", "category", "subCategory", "kpi"];


export const FIXED_TAG_GROUPS = [
  { name: "emission", label: "Emission" },
  { name: "energy", label: "Energy" },
  { name: "module", label: "Module" },
];

export const TAG_FIELDS = [
  { key: "module", label: "Module" },
  { key: "category", label: "Category" },
  { key: "subCategory", label: "Sub-category" },
  { key: "kpi", label: "KPI" },
];

export const KPI_STATUSES = [
  { value: "DRAFT", label: "Draft" },
  { value: "PUBLISHED", label: "Published" },
];

export const EVIDENCE_KINDS = [
  "Invoice",
  "Utility bill",
  "EB Bill Month Wise",
  "Certificate",
  "Waste manifest",
  "Policy document",
  "Photograph",
  "Third-party report",
];
